module.exports = __webpack_public_path__ + "img/logo_jspa.2127be2c.png";